/* @luxottica/virtual-mirror v7.4.0 */
function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

import { BipaManager } from '@luxottica/bipa-manager';
import { Catalog, GlassesEnvironment } from '@luxottica/vm-glasses';
import { RemoteLogConfig, RemoteLog } from '@luxottica/vm-remotelog';
import { combineReducers, createStore, compose } from 'redux';
import { createAction, handleActions } from 'redux-actions';
import ReactDOM from 'react-dom';
import { loginRequest } from '@luxottica/vto-microservices';
import PubSub from 'pubsub-js';
import { DeviceDetection } from '@luxottica/vm-devicedetection';
import device from 'current-device';
import { EventBus } from '@luxottica/vm-eventbus';
import { WebCam } from '@luxottica/vm-webcam';

const name = "@luxottica/virtual-mirror";
const version = "7.4.0";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var VtoError = /*#__PURE__*/function (_Error) {
  _inherits(VtoError, _Error);

  var _super = _createSuper(VtoError);

  function VtoError(type, errorSource, message) {
    var _this;

    _classCallCheck(this, VtoError);

    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "type", void 0);

    _defineProperty(_assertThisInitialized(_this), "adobeErrorParameters", void 0);

    _this.type = type;
    _this.message = message;
    _this.adobeErrorParameters = {
      errorSource: errorSource,
      errorCode: "Vm - ".concat(type),
      errorDetails: message
    };
    Object.setPrototypeOf(_assertThisInitialized(_this), VtoError.prototype);
    return _this;
  }

  return _createClass(VtoError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var InitializationError = /*#__PURE__*/function (_VtoError) {
  _inherits(InitializationError, _VtoError);

  var _super2 = _createSuper(InitializationError);

  function InitializationError() {
    var _this2;

    _classCallCheck(this, InitializationError);

    _this2 = _super2.call(this, InitializationError.type, 'Client', 'failed to initialize component');
    Object.setPrototypeOf(_assertThisInitialized(_this2), InitializationError.prototype);
    return _this2;
  }

  return _createClass(InitializationError);
}(VtoError);

_defineProperty(InitializationError, "type", 'InitializationError');

var NotInitializedError = /*#__PURE__*/function (_VtoError2) {
  _inherits(NotInitializedError, _VtoError2);

  var _super3 = _createSuper(NotInitializedError);

  function NotInitializedError() {
    var _this3;

    _classCallCheck(this, NotInitializedError);

    _this3 = _super3.call(this, NotInitializedError.type, 'Client', 'VirtualMirror must be initialized before rendering');
    Object.setPrototypeOf(_assertThisInitialized(_this3), NotInitializedError.prototype);
    return _this3;
  }

  return _createClass(NotInitializedError);
}(VtoError);

_defineProperty(NotInitializedError, "type", 'NotInitializedError');

var InvalidParametersError = /*#__PURE__*/function (_VtoError3) {
  _inherits(InvalidParametersError, _VtoError3);

  var _super4 = _createSuper(InvalidParametersError);

  function InvalidParametersError(parameter, value) {
    var _this4;

    _classCallCheck(this, InvalidParametersError);

    _this4 = _super4.call(this, InvalidParametersError.type, 'Client', "'".concat(parameter, ": ").concat(value, "' parameter is invalid"));
    Object.setPrototypeOf(_assertThisInitialized(_this4), InvalidParametersError.prototype);
    return _this4;
  }

  return _createClass(InvalidParametersError);
}(VtoError);

_defineProperty(InvalidParametersError, "type", 'InvalidParametersError');

var InvalidLocaleError = /*#__PURE__*/function (_VtoError4) {
  _inherits(InvalidLocaleError, _VtoError4);

  var _super5 = _createSuper(InvalidLocaleError);

  function InvalidLocaleError(locale) {
    var _this5;

    _classCallCheck(this, InvalidLocaleError);

    _this5 = _super5.call(this, InvalidLocaleError.type, 'Client', "invalid locale: ".concat(locale, " - supported format: aa-BB"));
    Object.setPrototypeOf(_assertThisInitialized(_this5), InvalidLocaleError.prototype);
    return _this5;
  }

  return _createClass(InvalidLocaleError);
}(VtoError);

_defineProperty(InvalidLocaleError, "type", 'InvalidLocaleError');

var RenderingError = /*#__PURE__*/function (_VtoError5) {
  _inherits(RenderingError, _VtoError5);

  var _super6 = _createSuper(RenderingError);

  function RenderingError(upc) {
    var _this6;

    _classCallCheck(this, RenderingError);

    _this6 = _super6.call(this, RenderingError.type, 'Client', "upc ".concat(upc, " failed to successfully render"));

    _defineProperty(_assertThisInitialized(_this6), "upc", void 0);

    _this6.upc = upc;
    Object.setPrototypeOf(_assertThisInitialized(_this6), RenderingError.prototype);
    return _this6;
  }

  return _createClass(RenderingError);
}(VtoError);

_defineProperty(RenderingError, "type", 'RenderingError');

var UpcSupportedError = /*#__PURE__*/function (_VtoError6) {
  _inherits(UpcSupportedError, _VtoError6);

  var _super7 = _createSuper(UpcSupportedError);

  function UpcSupportedError(upc) {
    var _this7;

    _classCallCheck(this, UpcSupportedError);

    _this7 = _super7.call(this, UpcSupportedError.type, 'Server', "failed to determine if upc ".concat(upc, " is supported"));

    _defineProperty(_assertThisInitialized(_this7), "upc", void 0);

    _this7.upc = upc;
    Object.setPrototypeOf(_assertThisInitialized(_this7), UpcSupportedError.prototype);
    return _this7;
  }

  return _createClass(UpcSupportedError);
}(VtoError);

_defineProperty(UpcSupportedError, "type", 'UpcSupportedError');

var UpcMissingError = /*#__PURE__*/function (_VtoError7) {
  _inherits(UpcMissingError, _VtoError7);

  var _super8 = _createSuper(UpcMissingError);

  function UpcMissingError(upc) {
    var _this8;

    _classCallCheck(this, UpcMissingError);

    _this8 = _super8.call(this, UpcMissingError.type, 'Server', "upc ".concat(upc, " could not be found"));

    _defineProperty(_assertThisInitialized(_this8), "upc", void 0);

    _this8.upc = upc;
    Object.setPrototypeOf(_assertThisInitialized(_this8), UpcMissingError.prototype);
    return _this8;
  }

  return _createClass(UpcMissingError);
}(VtoError);

_defineProperty(UpcMissingError, "type", 'UpcMissingError');

var MountComponentError = /*#__PURE__*/function (_VtoError8) {
  _inherits(MountComponentError, _VtoError8);

  var _super9 = _createSuper(MountComponentError);

  function MountComponentError(divId) {
    var _this9;

    _classCallCheck(this, MountComponentError);

    _this9 = _super9.call(this, MountComponentError.type, 'Client', "failed to mount component at divId: ".concat(divId));
    Object.setPrototypeOf(_assertThisInitialized(_this9), MountComponentError.prototype);
    return _this9;
  }

  return _createClass(MountComponentError);
}(VtoError);

_defineProperty(MountComponentError, "type", 'MountComponentError');

var UnmountComponentError = /*#__PURE__*/function (_VtoError9) {
  _inherits(UnmountComponentError, _VtoError9);

  var _super10 = _createSuper(UnmountComponentError);

  function UnmountComponentError(divId) {
    var _this10;

    _classCallCheck(this, UnmountComponentError);

    _this10 = _super10.call(this, UnmountComponentError.type, 'Client', "failed to unmount component at divId: ".concat(divId));
    Object.setPrototypeOf(_assertThisInitialized(_this10), UnmountComponentError.prototype);
    return _this10;
  }

  return _createClass(UnmountComponentError);
}(VtoError);

_defineProperty(UnmountComponentError, "type", 'UnmountComponentError');

var WebcamUnavailableError = /*#__PURE__*/function (_VtoError10) {
  _inherits(WebcamUnavailableError, _VtoError10);

  var _super11 = _createSuper(WebcamUnavailableError);

  function WebcamUnavailableError() {
    var _this11;

    _classCallCheck(this, WebcamUnavailableError);

    _this11 = _super11.call(this, WebcamUnavailableError.type, 'User', 'webcam support could not be found');
    _this11.adobeErrorParameters.errorCode = 'Vm - WebcamNotFoundError';
    Object.setPrototypeOf(_assertThisInitialized(_this11), WebcamUnavailableError.prototype);
    return _this11;
  }

  return _createClass(WebcamUnavailableError);
}(VtoError);

_defineProperty(WebcamUnavailableError, "type", 'WebcamUnavailableError');

var WebcamRejectedError = /*#__PURE__*/function (_VtoError11) {
  _inherits(WebcamRejectedError, _VtoError11);

  var _super12 = _createSuper(WebcamRejectedError);

  function WebcamRejectedError() {
    var _this12;

    _classCallCheck(this, WebcamRejectedError);

    _this12 = _super12.call(this, WebcamRejectedError.type, 'User', 'webcam access was rejected by user');
    Object.setPrototypeOf(_assertThisInitialized(_this12), WebcamRejectedError.prototype);
    return _this12;
  }

  return _createClass(WebcamRejectedError);
}(VtoError);

_defineProperty(WebcamRejectedError, "type", 'WebcamRejectedError');

var OpacityError = /*#__PURE__*/function (_VtoError12) {
  _inherits(OpacityError, _VtoError12);

  var _super13 = _createSuper(OpacityError);

  function OpacityError(message) {
    var _this13;

    _classCallCheck(this, OpacityError);

    _this13 = _super13.call(this, OpacityError.type, 'Client', message);
    Object.setPrototypeOf(_assertThisInitialized(_this13), OpacityError.prototype);
    return _this13;
  }

  return _createClass(OpacityError);
}(VtoError);

_defineProperty(OpacityError, "type", 'OpacityError');

var AnimationError = /*#__PURE__*/function (_VtoError13) {
  _inherits(AnimationError, _VtoError13);

  var _super14 = _createSuper(AnimationError);

  function AnimationError(message) {
    var _this14;

    _classCallCheck(this, AnimationError);

    _this14 = _super14.call(this, AnimationError.type, 'Client', message);
    Object.setPrototypeOf(_assertThisInitialized(_this14), AnimationError.prototype);
    return _this14;
  }

  return _createClass(AnimationError);
}(VtoError);

_defineProperty(AnimationError, "type", 'AnimationError');

var MissingAuthKeyError = /*#__PURE__*/function (_VtoError14) {
  _inherits(MissingAuthKeyError, _VtoError14);

  var _super15 = _createSuper(MissingAuthKeyError);

  function MissingAuthKeyError() {
    var _this15;

    _classCallCheck(this, MissingAuthKeyError);

    _this15 = _super15.call(this, MissingAuthKeyError.type, 'Client', 'Virtual Mirror requires a key to work');
    Object.setPrototypeOf(_assertThisInitialized(_this15), MissingAuthKeyError.prototype);
    return _this15;
  }

  return _createClass(MissingAuthKeyError);
}(VtoError);

_defineProperty(MissingAuthKeyError, "type", 'MissingAuthKeyError');

var FeatureInitializationError = /*#__PURE__*/function (_VtoError15) {
  _inherits(FeatureInitializationError, _VtoError15);

  var _super16 = _createSuper(FeatureInitializationError);

  function FeatureInitializationError() {
    var _this16;

    _classCallCheck(this, FeatureInitializationError);

    _this16 = _super16.call(this, FeatureInitializationError.type, 'Client', 'Virtual Mirror feature service failed to initialize');
    Object.setPrototypeOf(_assertThisInitialized(_this16), FeatureInitializationError.prototype);
    return _this16;
  }

  return _createClass(FeatureInitializationError);
}(VtoError);

_defineProperty(FeatureInitializationError, "type", 'FeatureInitializationError');

var FeatureUnavailableError = /*#__PURE__*/function (_VtoError16) {
  _inherits(FeatureUnavailableError, _VtoError16);

  var _super17 = _createSuper(FeatureUnavailableError);

  function FeatureUnavailableError(feature) {
    var _this17;

    _classCallCheck(this, FeatureUnavailableError);

    _this17 = _super17.call(this, FeatureUnavailableError.type, 'Client', "feature ".concat(feature, " is not available for this client"));
    Object.setPrototypeOf(_assertThisInitialized(_this17), FeatureUnavailableError.prototype);
    return _this17;
  }

  return _createClass(FeatureUnavailableError);
}(VtoError);

_defineProperty(FeatureUnavailableError, "type", 'FeatureUnavailableError');

var FeatureUndefinedError = /*#__PURE__*/function (_VtoError17) {
  _inherits(FeatureUndefinedError, _VtoError17);

  var _super18 = _createSuper(FeatureUndefinedError);

  function FeatureUndefinedError() {
    var _this18;

    _classCallCheck(this, FeatureUndefinedError);

    _this18 = _super18.call(this, FeatureUndefinedError.type, 'Client', 'Can\'t get auth for undefined feature');
    Object.setPrototypeOf(_assertThisInitialized(_this18), FeatureUndefinedError.prototype);
    return _this18;
  }

  return _createClass(FeatureUndefinedError);
}(VtoError);

_defineProperty(FeatureUndefinedError, "type", 'FeatureUndefinedError');

var FeatureServerError = /*#__PURE__*/function (_VtoError18) {
  _inherits(FeatureServerError, _VtoError18);

  var _super19 = _createSuper(FeatureServerError);

  function FeatureServerError(e) {
    var _this19;

    _classCallCheck(this, FeatureServerError);

    _this19 = _super19.call(this, FeatureServerError.type, 'Server', e.message);
    Object.setPrototypeOf(_assertThisInitialized(_this19), FeatureServerError.prototype);
    return _this19;
  }

  return _createClass(FeatureServerError);
}(VtoError);

_defineProperty(FeatureServerError, "type", 'FeatureServerError');

var DefaultInitializationOptions = {
  key: undefined,
  analyticsConfig: {},
  brand: undefined,
  channel: undefined,
  storeId: undefined,
  locale: 'en-US',
  environment: 'PRODUCTION',
  sessionTimeout: false
};

var VM_SKIP_AKAMAI_LICENSING_FLAG = 'vm.akamai.licensing.skip';
window.VMAkamaiLicensingFlag = VM_SKIP_AKAMAI_LICENSING_FLAG;
var config = {
  STAGING: {
    get baseUrl() {
      if (overrideAkamai()) {
        return 'https://test-gateway-vtoprofile.luxdeepblue.com/services/vtomoduleprotection/public/v1/';
      } else {
        return 'https://test-gateway-vtoprofile.luxdeepblue.com/services/vtomoduleprotection/public/v1/';
      }
    },

    getAllFeaturesPath: 'get-functionalities/',
    getKeyAuthorizationPath: 'key-authorized/'
  },
  ACCEPTANCE: {
    get baseUrl() {
      // tslint:disable-next-line: no-console
      console.warn('backoffice for feature licensing development env will be changed soon');

      if (overrideAkamai()) {
        return 'https://acceptance-gateway-vtoprofile.luxdeepblue.com/services/vtomoduleprotection/public/v1/';
      } else {
        return 'https://vmcore-test.luxottica.com/services/vtomoduleprotection/public/v1/';
      }
    },

    getAllFeaturesPath: 'get-functionalities/',
    getKeyAuthorizationPath: 'key-authorized/'
  },
  PRODUCTION: {
    get baseUrl() {
      if (overrideAkamai()) {
        return 'https://gateway-vtoprofile.luxdeepblue.com/services/vtomoduleprotection/public/v1/';
      } else {
        return 'https://vmcore.luxottica.com/services/vtomoduleprotection/public/v1/';
      }
    },

    getAllFeaturesPath: 'get-functionalities/',
    getKeyAuthorizationPath: 'key-authorized/'
  }
};
var defaultFeatures = new Map([]);

var overrideAkamai = function overrideAkamai() {
  if (!!window && !!window.localStorage) {
    return window.localStorage.getItem(VM_SKIP_AKAMAI_LICENSING_FLAG) === 'true';
  } else {
    return false;
  }
};

var getFeatureConfig = function getFeatureConfig(environment) {
  return config[environment];
};

var Features;

(function (Features) {
  Features["VM_TRANSITIONS"] = "VM_TRANSITIONS";
  Features["VM_SCREENSHOT"] = "VM_SCREENSHOT";
  Features["VM_MOVE_GLASSES"] = "VM_MOVE_GLASSES";
  Features["VM_ANALYTICS"] = "VM_ANALYTICS";
  Features["VM_TAP_TO_PAUSE"] = "VM_TAP_TO_PAUSE";
  Features["VM_BIPA"] = "VM_BIPA";
  Features["VM_GET_BIPA_VERSION"] = "VM_GET_BIPA_VERSION";
  Features["VM_SAVE_BIPA_ENTRY"] = "VM_SAVE_BIPA_ENTRY";
})(Features || (Features = {}));

var logger$a = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'FeatureLicensingService');
var _isInitialized = false;
var currentLicenseKey;
var currentEnvironment = DefaultInitializationOptions.environment;
var featureSupportCache;

var featureListUrl = function featureListUrl() {
  if (currentLicenseKey === undefined) {
    throw new MissingAuthKeyError();
  }

  var config = getFeatureConfig(currentEnvironment);
  logger$a.debug('Getting feature list for key {} using config {}', currentLicenseKey, JSON.stringify(config));
  return "".concat(config.baseUrl).concat(config.getAllFeaturesPath).concat(currentLicenseKey);
};

var getFeatureMap = function getFeatureMap() {
  return new Promise(function (resolve, reject) {
    try {
      var url = featureListUrl();
      resolve(url);
    } catch (e) {
      reject(e);
    }
  }).then(function (url) {
    return fetch(url);
  }).then(function (res) {
    return res.ok ? res.json() : Promise.reject(new FeatureServerError("".concat(res.status, " - ").concat(res.statusText)));
  }).then(function (json) {
    var featureMap = new Map();
    Object.values(Features).forEach(function (feature) {
      featureMap.set(feature, json.includes(feature.toString()));
    });
    logger$a.debug('client feature list has been imported {}', _toConsumableArray(featureMap.entries()));
    return featureMap;
  })["catch"](function (e) {
    var error = e instanceof MissingAuthKeyError || e instanceof FeatureServerError ? e : new FeatureServerError(e.message);
    logger$a.error(error);
    throw error;
  });
};

var reset = function reset() {
  _isInitialized = false;
  return getFeatureMap().then(function (featureMap) {
    featureSupportCache = featureMap;
    _isInitialized = true;
  })["catch"](function (e) {
    featureSupportCache = defaultFeatures;
    throw e;
  });
};

var FeatureLicensingService = {
  initialize: function initialize(licenseKey, environment) {
    var shouldReset = false;

    if (!_isInitialized) {
      shouldReset = true;
    }

    if (!!licenseKey && licenseKey !== currentLicenseKey) {
      currentLicenseKey = licenseKey;
      shouldReset = true;
    }

    if (!!environment && environment !== currentEnvironment) {
      currentEnvironment = environment;
      shouldReset = true;
    }

    return shouldReset ? reset() : Promise.resolve();
  },
  isInitialized: function isInitialized() {
    return _isInitialized;
  },
  isFeatureAuthorized: function isFeatureAuthorized() {
    for (var _len = arguments.length, features = new Array(_len), _key = 0; _key < _len; _key++) {
      features[_key] = arguments[_key];
    }

    if (!!features && !!featureSupportCache) {
      return features.every(function (feature) {
        return !!featureSupportCache.get(feature);
      });
    } else {
      throw new FeatureInitializationError();
    }
  }
};

var SET_ENVIRONMENT = 'SET_ENVIRONMENT';
var SET_AUTH = 'SET_AUTH';
var RESET_AUTH = 'RESET_AUTH';
var SET_LOADING_STATUS = 'SET_LOADING_STATUS';
var SET_PRIVACY_OPTIONS = 'SET_PRIVACY_OPTIONS';
var SET_USER = 'SET_USER';
var SET_MIRROR_OPTIONS = 'SET_MIRROR_OPTIONS';
var SET_MIRROR_STATUS = 'SET_MIRROR_STATUS';
var SET_MIRROR_GLASSES = 'SET_MIRROR_GLASSES';
var SET_MIRROR_GLASSES_DATA = 'SET_MIRROR_GLASSES_DATA';
var SET_MIRROR_GLASSES_STATUS = 'SET_MIRROR_GLASSES_STATUS';
var SET_GLTF_MIRROR_GLASSES_STATUS = 'SET_GLTF_MIRROR_GLASSES_STATUS';
var SET_MESH = 'SET_MESH';
var SET_MESH_DATA = 'SET_MESH_DATA';
var SET_MESH_STATUS = 'SET_MESH_STATUS';

var _handleActions$1;
var initialState$2 = {
  environment: 'PRODUCTION',
  loading: {
    WEBCAM_ACCESS: false,
    INITIALIZATION: false,
    POSETRACKER: false,
    RENDERING: false,
    GLASSES: false,
    MESH: false
  },
  privacy: {},
  auth: {
    accessToken: undefined,
    refreshToken: undefined
  }
};
var AppActions = {
  setEnvironment: createAction(SET_ENVIRONMENT),
  setAuth: createAction(SET_AUTH),
  resetAuth: createAction(RESET_AUTH),
  setPrivacyOptions: createAction(SET_PRIVACY_OPTIONS),
  setLoadingStatus: createAction(SET_LOADING_STATUS)
};
var AppReducer = handleActions((_handleActions$1 = {}, _defineProperty(_handleActions$1, SET_ENVIRONMENT, function (state, action) {
  return !!action.payload ? _objectSpread2(_objectSpread2({}, state), {}, {
    environment: action.payload
  }) : _objectSpread2({}, state);
}), _defineProperty(_handleActions$1, SET_AUTH, function (state, action) {
  if (!!action.payload.accessToken && !!action.payload.refreshToken) {
    return _objectSpread2(_objectSpread2({}, state), {}, {
      auth: {
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken
      }
    });
  } else {
    return _objectSpread2({}, state);
  }
}), _defineProperty(_handleActions$1, RESET_AUTH, function (state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    auth: {
      accessToken: undefined,
      refreshToken: undefined
    }
  });
}), _defineProperty(_handleActions$1, SET_PRIVACY_OPTIONS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    privacy: _objectSpread2({}, action.payload)
  });
}), _defineProperty(_handleActions$1, SET_LOADING_STATUS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    loading: _objectSpread2(_objectSpread2({}, state.loading), {}, _defineProperty({}, action.payload.type, action.payload.status))
  });
}), _handleActions$1), initialState$2);

var _handleActions;
var initialState$1 = {
  glasses: undefined,
  video: undefined,
  mirrorStatus: 'LOADING',
  mirrorOptions: undefined
};
var MirrorActions = {
  setMirrorOptions: createAction(SET_MIRROR_OPTIONS),
  setMirrorStatus: createAction(SET_MIRROR_STATUS),
  setMirrorGlasses: createAction(SET_MIRROR_GLASSES),
  setMirrorGlassesData: createAction(SET_MIRROR_GLASSES_DATA),
  setMirrorGlassesStatus: createAction(SET_MIRROR_GLASSES_STATUS),
  setGltfMirrorGlassesStatus: createAction(SET_GLTF_MIRROR_GLASSES_STATUS),
  setMesh: createAction(SET_MESH),
  setMeshData: createAction(SET_MESH_DATA),
  setMeshStatus: createAction(SET_MESH_STATUS)
};
var MirrorReducer = handleActions((_handleActions = {}, _defineProperty(_handleActions, SET_MIRROR_OPTIONS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    mirrorOptions: action.payload
  });
}), _defineProperty(_handleActions, SET_MIRROR_STATUS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    mirrorStatus: action.payload
  });
}), _defineProperty(_handleActions, SET_MIRROR_GLASSES, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    glasses: {
      upc: action.payload.upc,
      type: action.payload.type,
      status: 'LOADING'
    }
  });
}), _defineProperty(_handleActions, SET_MIRROR_GLASSES_DATA, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    glasses: action.payload
  });
}), _defineProperty(_handleActions, SET_MIRROR_GLASSES_STATUS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    glasses: _objectSpread2(_objectSpread2({}, state.glasses), {}, {
      upc: action.payload.upc,
      status: action.payload.status
    })
  });
}), _defineProperty(_handleActions, SET_GLTF_MIRROR_GLASSES_STATUS, function (state, action) {
  return action.payload.upc === state.glasses.upc ? _objectSpread2(_objectSpread2({}, state), {}, {
    glasses: _objectSpread2(_objectSpread2({}, state.glasses), {}, {
      upc: action.payload.upc,
      status: action.payload.status
    })
  }) : _objectSpread2({}, state);
}), _defineProperty(_handleActions, SET_MESH, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    video: {
      videoId: action.payload.videoId,
      pupillaryDistance: action.payload.pupillaryDistance,
      status: 'LOADING'
    }
  });
}), _defineProperty(_handleActions, SET_MESH_DATA, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    video: _objectSpread2(_objectSpread2(_objectSpread2({}, state.video), action.payload), {}, {
      status: 'READY'
    })
  });
}), _defineProperty(_handleActions, SET_MESH_STATUS, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    video: _objectSpread2(_objectSpread2({}, state.video), {}, {
      videoId: action.payload.videoId,
      status: action.payload.status
    })
  });
}), _handleActions), initialState$1);

var initialState = {
  locale: 'en-US',
  region: undefined,
  source: undefined,
  brand: undefined,
  storeId: undefined,
  channel: undefined
};
var UserActions = {
  setUser: createAction(SET_USER)
};
var UserReducer = handleActions(_defineProperty({}, SET_USER, function (state, action) {
  return _objectSpread2(_objectSpread2({}, state), action.payload);
}), initialState);

var rootReducer = combineReducers({
  app: AppReducer,
  mirror: MirrorReducer,
  user: UserReducer
});

function configureStore(initialState) {
  var composeEnhancers = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: 'virtual-mirror'
  }) : compose;
  var enhancer = composeEnhancers();
  return createStore(rootReducer, initialState, enhancer);
}

var VmStore;

var vmIsInitialized = function vmIsInitialized() {
  return VmStore !== undefined && VmStore.getState().app.loading.INITIALIZATION === true;
};

var configureVmStore = function configureVmStore() {
  VmStore = configureStore();
};

var performanceEvents = {
  onEngineStarting: 'onEngineStarting',
  onFirstFrameRendered: 'onFirstFrameRendered',
  onNewAssetRequested: 'onNewAssetRequested',
  onWaitingForPose: 'onWaitingForPose',
  onFirstFrameStarted: 'onFirstFrameStarted',
  onAssetSwitchDone: 'onAssetSwitchDone',
  onNewTransitionRequested: 'onNewTransitionRequested',
  onNewTransitionRendered: 'onNewTransitionRendered',
  onFPSCount: 'onFPSCount'
};
var DOMDefaultTarget = function DOMDefaultTarget() {
  return document.querySelector('body');
};

var onFaceFoundSet = false;
var dispatchEvent = function dispatchEvent(domEvent) {
  var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  DOMDefaultTarget().dispatchEvent(new CustomEvent(domEvent, details));
};

var setPrivacyCallbacks = function setPrivacyCallbacks(privacyCallbacks) {
  if (privacyCallbacks) {
    for (var callback in privacyCallbacks) {
      if (privacyCallbacks[callback]) {
        CallbackHelper[callback] = privacyCallbacks[callback];
      }
    }
  }
};

var setCallbacks = function setCallbacks(callbacks) {
  CallbackHelper.onAuthUpdated = function (authData) {
    var _callbacks$onAuthUpda;

    VmStore.dispatch(AppActions.setAuth(authData));
    callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onAuthUpda = callbacks.onAuthUpdated) === null || _callbacks$onAuthUpda === void 0 ? void 0 : _callbacks$onAuthUpda.call(callbacks, authData);
  };

  if (callbacks) {
    if (callbacks.onFaceFound) {
      onFaceFoundSet = true;
      CallbackHelper.onFaceFound = callbacks.onFaceFound;
    }

    if (callbacks.onLowEndDeviceDetected) {
      CallbackHelper.onLowEndDeviceDetected = callbacks.onLowEndDeviceDetected;
    }

    if (callbacks.onTransitionAnimation) {
      CallbackHelper.onTransitionAnimation = callbacks.onTransitionAnimation;
    }

    if (callbacks.onTransitionAnimationEnd) {
      CallbackHelper.onTransitionAnimationEnd = callbacks.onTransitionAnimationEnd;
    }
  }
};

var useBiometricBipa = function useBiometricBipa() {
  return onFaceFoundSet;
};

var CallbackHelper = {
  onFaceFound: function onFaceFound() {
    return;
  },
  onLowEndDeviceDetected: function onLowEndDeviceDetected() {
    return;
  },
  onTransitionAnimation: function onTransitionAnimation() {
    return;
  },
  onTransitionAnimationEnd: function onTransitionAnimationEnd() {
    return;
  },
  onAuthUpdated: function onAuthUpdated() {
    return;
  },
  onDisplayPage: function onDisplayPage() {
    return;
  },
  onPrivacyAgree: function onPrivacyAgree() {
    return;
  },
  onPrivacyFail: function onPrivacyFail() {
    return;
  },
  onPrivacyReject: function onPrivacyReject() {
    return;
  },
  onPrivacyPolicyClick: undefined,
  onTermsAndConditionsClick: undefined,
  onPrivacyDisplay: function onPrivacyDisplay() {
    return;
  },
  onMirrorExperience: function onMirrorExperience() {
    return;
  }
};

var transitionColorMap = {};
var transitionOpacity = 0.0;
var finalOpacity;
var animationEnabled = false;
var animateForward = false;
var animationStartTime;
var animationDuration;

var computePartialAnimation = function computePartialAnimation(forward, duration, currentOpacity) {
  return forward ? Date.now() - duration * currentOpacity : Date.now() - duration * (1 - currentOpacity);
};

var TransitionColorHelper = {
  downloadTransitionColors: function downloadTransitionColors(config) {
    if (Object.keys(transitionColorMap).length !== 0) {
      return Promise.resolve();
    } else {
      if (FeatureLicensingService.isFeatureAuthorized(Features.VM_TRANSITIONS)) {
        return Catalog.downloadTransitionColors(config).then(function (colorMap) {
          Object.keys(colorMap).map(function (colorName) {
            transitionColorMap[colorName] = {
              mirror: colorMap[colorName].mirror,
              active: colorMap[colorName].active,
              clear: colorMap[colorName].clear
            };
          });
        });
      } else {
        return Promise.resolve();
      }
    }
  },
  setTransitionOverrideColor: function setTransitionOverrideColor(color) {
    transitionColorMap.OVERRIDE = color;
  },
  reset: function reset() {
    animationEnabled = false;
    finalOpacity = undefined;
  },
  startAnimation: function startAnimation(duration) {
    if (!animationEnabled) {
      animationEnabled = true;
      animationDuration = duration;
      animateForward = transitionOpacity < 0.5;
      animationStartTime = transitionOpacity % 1 === 0 ? Date.now() : computePartialAnimation(animateForward, animationDuration, transitionOpacity);
      finalOpacity = undefined;
    }
  },
  getTransitionColor: function getTransitionColor(colorName) {
    return transitionColorMap === null || transitionColorMap === void 0 ? void 0 : transitionColorMap[colorName];
  },
  setCurrentLensOpacity: function setCurrentLensOpacity(inputOpacity) {
    TransitionColorHelper.reset();
    transitionOpacity = inputOpacity;
  },
  getCurrentLensOpacity: function getCurrentLensOpacity() {
    if (finalOpacity !== undefined || !animationEnabled) {
      return transitionOpacity;
    } else {
      var animationProgress = (Date.now() - animationStartTime) / animationDuration;

      if (animationProgress >= 1.0) {
        animationProgress = 1.0;
        animationEnabled = false;
      }

      transitionOpacity = animateForward ? animationProgress : 1.0 - animationProgress;

      if (animationProgress === 1.0) {
        finalOpacity = transitionOpacity;
        CallbackHelper.onTransitionAnimationEnd(finalOpacity);
      }

      CallbackHelper.onTransitionAnimation(transitionOpacity);
      return transitionOpacity;
    }
  }
};

var animateOpacity = function animateOpacity() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

  if (!vmIsInitialized()) {
    return;
  }

  if ((VmStore === null || VmStore === void 0 ? void 0 : VmStore.getState().mirror.mirrorStatus) === 'TRACKING') {
    if (!VmStore.getState().mirror.glasses.transitionAvailable) {
      var error = new AnimationError('animateOpacity cannot be triggered when transition is not available for this asset');
      throw error;
    }

    if (duration === undefined || typeof duration !== 'number' || duration <= 0) {
      var _error = new AnimationError('animateOpacity cannot be triggered when duration value is invalid');

      throw _error;
    }

    TransitionColorHelper.startAnimation(duration);
  } else {
    var _error2 = new AnimationError('animateOpacity cannot be triggered when mirror is not rendering');

    throw _error2;
  }
};

var AppViewSessionKeys;

(function (AppViewSessionKeys) {
  AppViewSessionKeys["VM_OK"] = "vm-ok";
  AppViewSessionKeys["VM_KO"] = "vm-ko";
  AppViewSessionKeys["VM_INIT"] = "_init";
  AppViewSessionKeys["VM_INIT_BRAND"] = "_init_brand";
  AppViewSessionKeys["VM_INIT_CHANNEL"] = "_init_channel";
  AppViewSessionKeys["VM_INIT_LOCALE"] = "_init_locale";
  AppViewSessionKeys["VM_CLOSE"] = "_close";
  AppViewSessionKeys["VM_FITMEBETTER"] = "_fitmebetter";
  AppViewSessionKeys["VM_SCREENSHOT"] = "_screenshot";
  AppViewSessionKeys["VM_RENDER"] = "_render";
  AppViewSessionKeys["VM_RENDER_TIME"] = "_render_time_ms";
  AppViewSessionKeys["VM_UPC_AVAILABILITY"] = "_upc_availability";
})(AppViewSessionKeys || (AppViewSessionKeys = {}));

var vmRemoteLog = new RemoteLog();

var createLogger = function createLogger(loggerName) {
  return RemoteLogConfig.getInstance().getLoggerInfo(name, version, loggerName);
};

var sendError = function sendError(e) {
  vmRemoteLog.sendAppViewSession({
    statusCode: '99-error',
    statusText: e.message
  });
};

var sendAppViewSession = {
  initialize: function initialize(options) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_INIT_BRAND,
      statusText: options.brand
    }, {
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_INIT_CHANNEL,
      statusText: options.channel
    }, {
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_INIT_LOCALE,
      statusText: options.locale
    });
  },
  initializeError: function initializeError(options) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_KO + AppViewSessionKeys.VM_INIT,
      statusText: options.channel
    });
  },
  upc: function upc(_upc) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_UPC_AVAILABILITY,
      statusText: _upc
    });
  },
  upcError: function upcError(upc) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_KO + AppViewSessionKeys.VM_UPC_AVAILABILITY,
      statusText: upc
    });
  },
  orientationChange: function orientationChange(landscape) {
    vmRemoteLog.sendAppViewSession({
      statusCode: 'orientation change',
      statusText: landscape ? 'landscape' : 'portrait'
    });
  },
  fitMeBetter: function fitMeBetter() {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_FITMEBETTER,
      statusText: ''
    });
  },
  fitMeBetterError: function fitMeBetterError() {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_KO + AppViewSessionKeys.VM_FITMEBETTER,
      statusText: ''
    });
  },
  close: function close(target) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_OK + AppViewSessionKeys.VM_CLOSE,
      statusText: target
    });
  },
  closeError: function closeError(target) {
    vmRemoteLog.sendAppViewSession({
      statusCode: AppViewSessionKeys.VM_KO + AppViewSessionKeys.VM_CLOSE,
      statusText: target
    });
  }
};

var adobeConfig;
var environment;
var logger$9 = createLogger('AdobeHelper');

var generateAdobeData = function generateAdobeData(eventParams, errorParams) {
  var _adobeConfig, _adobeConfig2, _adobeConfig3, _adobeConfig4, _adobeConfig5, _adobeConfig6, _adobeConfig7;

  var adobeData = new Map();
  adobeData.set('AQB', '1');
  adobeData.set('ndh', '1');
  adobeData.set('ns', 'luxottica');
  adobeData.set('g', window.location.href);
  adobeData.set('r', document.referrer);
  adobeData.set('ch', 'VirtualMirror');
  adobeData.set('server', window.location.hostname);
  adobeData.set('c1', (_adobeConfig = adobeConfig) === null || _adobeConfig === void 0 ? void 0 : _adobeConfig.channel);
  adobeData.set('c2', (_adobeConfig2 = adobeConfig) === null || _adobeConfig2 === void 0 ? void 0 : _adobeConfig2.storeId);
  adobeData.set('c3', (_adobeConfig3 = adobeConfig) === null || _adobeConfig3 === void 0 ? void 0 : _adobeConfig3.brand);
  adobeData.set('c4', (_adobeConfig4 = adobeConfig) === null || _adobeConfig4 === void 0 ? void 0 : _adobeConfig4.locale);
  adobeData.set('c5', eventParams.upc);
  adobeData.set('c6', (_adobeConfig5 = adobeConfig) === null || _adobeConfig5 === void 0 ? void 0 : _adobeConfig5.storeRegion);
  adobeData.set('c7', (_adobeConfig6 = adobeConfig) === null || _adobeConfig6 === void 0 ? void 0 : _adobeConfig6.storeCompany);
  adobeData.set('c8', (_adobeConfig7 = adobeConfig) === null || _adobeConfig7 === void 0 ? void 0 : _adobeConfig7.globalStoreId);
  adobeData.set('c9', version);
  var lensSim;

  if (!!eventParams.lensName && FeatureLicensingService.isFeatureAuthorized(Features.VM_TRANSITIONS)) {
    lensSim = 'transition';
  } else if (!!eventParams.upc) {
    lensSim = 'standard';
  } else {
    lensSim = 'undefined';
  }

  adobeData.set('c11', lensSim);

  if (errorParams) {
    adobeData.set('v1', errorParams.errorSource);
    adobeData.set('v2', errorParams.errorCode);
    adobeData.set('v3', errorParams.errorDetails);
    adobeData.set('v5', eventParams.upc);
  }

  adobeData.set('events', eventParams.eventCode);
  adobeData.set('pageName', 'VirtualMirror');
  adobeData.set('AQE', '1');
  return adobeData;
};

var sendAdobeRequest = function sendAdobeRequest(data) {
  var adobeHost = environment === 'PRODUCTION' ? 'https://luxottica.d2.sc.omtrdc.net/b/ss/lux-virtualmirror-prod/1?' : 'https://luxottica.d2.sc.omtrdc.net/b/ss/lux-virtualmirror-dev/1?';
  var query = Array.from(data.keys()).filter(function (key) {
    return data.get(key) !== undefined;
  }).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(data.get(key));
  }).join('&');
  var adobeQuery = "".concat(adobeHost).concat(query);
  logger$9.debug('sending adobe analytics event: {}', JSON.stringify({
    abobeHost: adobeHost,
    entries: _toConsumableArray(data.entries())
  }));
  return fetch(adobeQuery, {
    method: 'POST'
  })["catch"](function (e) {
    logger$9.warn('failed to post analytics event {}', JSON.stringify(e));
  });
};

var AdobeHelper = {
  initialize: function initialize(config, msEnvironment) {
    adobeConfig = config;
    environment = msEnvironment === 'PRODUCTION' ? 'PRODUCTION' : 'DEVELOPMENT';
  },
  sendEvent: function sendEvent(eventParams) {
    if (FeatureLicensingService.isFeatureAuthorized(Features.VM_ANALYTICS)) {
      try {
        var adobeData = generateAdobeData(eventParams);
        sendAdobeRequest(adobeData);
      } catch (e) {
        logger$9.error(e);
      }
    }
  },
  sendError: function sendError(vtoError, upc) {
    if (!FeatureLicensingService.isInitialized()) {
      throw new FeatureInitializationError();
    }

    if (FeatureLicensingService.isFeatureAuthorized(Features.VM_ANALYTICS)) {
      try {
        if (['InitializationError', 'InvalidParametersError', 'UpcSupportedError', 'UpcMissingError', 'WebcamUnavailableError', 'WebcamRejectedError', 'MountComponentError', 'UnmountComponentError'].includes(vtoError === null || vtoError === void 0 ? void 0 : vtoError.type)) {
          var adobeErrorData = generateAdobeData({
            eventCode: 'event8',
            upc: upc
          }, vtoError.adobeErrorParameters);
          sendAdobeRequest(adobeErrorData);
        }
      } catch (e) {
        logger$9.error(e);
      }
    }
  }
};

var analyticsConfig;
var lastInteractionTime;
var sessionTimeoutMs;
var FIVE_MINUTES = 5 * 60 * 1000;

var setSessionTimeout = function setSessionTimeout(sessionTimeout) {
  sessionTimeoutMs = sessionTimeout ? FIVE_MINUTES : Infinity;
};

var updateInteractionTime = function updateInteractionTime() {
  if (lastInteractionTime) {
    lastInteractionTime = Date.now();
  }
};

var sendEvent = function sendEvent(eventName) {
  try {
    if (eventName in analyticsConfig) {
      if (analyticsConfig[eventName] !== undefined) {
        var _analyticsConfig;

        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        (_analyticsConfig = analyticsConfig)[eventName].apply(_analyticsConfig, params);
      }
    }
  } catch (e) {
    // tslint:disable-next-line: no-console
    console.error('Analytics Event Failed');
  }
};

var AnalyticsHelper = {
  initialize: function initialize(environment) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var adobeConfig = arguments.length > 2 ? arguments[2] : undefined;
    updateInteractionTime();
    analyticsConfig = config;
    AdobeHelper.initialize(adobeConfig, environment);
  },
  onSessionStart: function onSessionStart() {
    if (!lastInteractionTime || Date.now() - lastInteractionTime > sessionTimeoutMs) {
      lastInteractionTime = Date.now();
      AdobeHelper.sendEvent({
        eventCode: 'event1'
      });
      sendEvent('onSessionStart');
    }
  },
  onInitializeSuccess: function onInitializeSuccess() {
    updateInteractionTime();
    sendEvent('onInitializeSuccess');
  },
  onInitializeError: function onInitializeError() {
    updateInteractionTime();
    AdobeHelper.sendError(new InitializationError());
    sendEvent('onInitializeError');
  },
  onRequestWebcam: function onRequestWebcam() {
    updateInteractionTime();
    AdobeHelper.sendEvent({
      eventCode: 'event2'
    });
    sendEvent('onRequestWebcam');
  },
  onWebcamAllowed: function onWebcamAllowed() {
    updateInteractionTime();
    AdobeHelper.sendEvent({
      eventCode: 'event3'
    });
    sendEvent('onWebcamAllowed');
  },
  onWebcamDenied: function onWebcamDenied() {
    updateInteractionTime();
    AdobeHelper.sendError(new WebcamRejectedError());
    sendEvent('onWebcamDenied');
  },
  onWebcamUnavailable: function onWebcamUnavailable() {
    updateInteractionTime();
    AdobeHelper.sendError(new WebcamUnavailableError());
    sendEvent('onWebcamUnavailable');
  },
  onMirrorWasmFailure: function onMirrorWasmFailure() {
    updateInteractionTime();
    sendEvent('onMirrorWasmFailure');
  },
  onGlassesOn: function onGlassesOn() {
    updateInteractionTime();
    sendEvent('onGlassesOn');
  },
  onGlassesOff: function onGlassesOff() {
    updateInteractionTime();
    sendEvent('onGlassesOff');
  },
  onRender: function onRender(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    sendEvent('onRender', upcIdLens);
  },
  onRenderReady: function onRenderReady(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    AdobeHelper.sendEvent({
      eventCode: !!upcIdLens ? "event4:".concat(upcIdLens) : 'event4',
      upc: upcIdLens,
      lensName: lensName
    });
    sendEvent('onRenderReady', upcIdLens);
  },
  onMirrorRenderFailure: function onMirrorRenderFailure(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    sendEvent('onMirrorRenderFailure', upcIdLens);
  },
  onFitGlasses: function onFitGlasses(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    AdobeHelper.sendEvent({
      eventCode: !!upcIdLens ? "event5:".concat(upcIdLens) : 'event5',
      upc: upcIdLens,
      lensName: lensName
    });
    sendEvent('onFitGlasses');
  },
  onAdjustGlasses: function onAdjustGlasses(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    AdobeHelper.sendEvent({
      eventCode: !!upcIdLens ? "event6:".concat(upcIdLens) : 'event6',
      upc: upcIdLens,
      lensName: lensName
    });
    sendEvent('onAdjustGlasses'); // TODO: should this have upc?
  },
  onCloseMirror: function onCloseMirror() {
    updateInteractionTime();
    AdobeHelper.sendEvent({
      eventCode: 'event7'
    });
    sendEvent('onCloseMirror');
  },
  onError: function onError() {
    updateInteractionTime();
    sendEvent('onError');
  },
  onScreenshot: function onScreenshot(upc, lensName) {
    updateInteractionTime();
    var upcIdLens = upcLensName(upc, lensName);
    AdobeHelper.sendEvent({
      eventCode: !!upcIdLens ? "event9:".concat(upcIdLens) : 'event9',
      upc: upcIdLens,
      lensName: lensName
    });
    sendEvent('onScreenshot');
  }
};

var upcLensName = function upcLensName(upc, lensName) {
  return !!lensName ? "".concat(upc, "_").concat(lensName) : upc;
};

var logger$8 = createLogger('CloseMirror');

var resetLoadingStatus = function resetLoadingStatus() {
  VmStore.dispatch(AppActions.setLoadingStatus({
    type: 'WEBCAM_ACCESS',
    status: false
  }));
  VmStore.dispatch(AppActions.setLoadingStatus({
    type: 'RENDERING',
    status: false
  }));
  VmStore.dispatch(AppActions.setLoadingStatus({
    type: 'POSETRACKER',
    status: false
  }));
}; // we return a promise because it's easy to keep this backwards compatibility here
// but sneaky on client code


var closeMirror = function closeMirror(target) {
  try {
    // reset all loading statuses, this will display the loading screen again on a new VM instance
    resetLoadingStatus();
    AnalyticsHelper.onCloseMirror();
    logger$8.debug('closing mirror for target div {}', target);
    var container = document.getElementById(target);

    if (ReactDOM.unmountComponentAtNode(container)) {
      logger$8.debug('closed mirror for target div {}', target);
      sendAppViewSession.close(target);
    } else {
      logger$8.debug('closing mirror for target div {} failed', target);
      sendAppViewSession.closeError(target);
      var unmountComponentError = new UnmountComponentError(target);
      AdobeHelper.sendError(unmountComponentError);
      return Promise.reject(unmountComponentError);
    }

    return Promise.resolve();
  } catch (e) {
    logger$8.debug('closing mirror for target div {} failed: {}', target, e.message);

    var _unmountComponentError = new UnmountComponentError(target);

    try {
      AdobeHelper.sendError(_unmountComponentError);
    } catch (e) {
      return Promise.reject(e);
    }

    return Promise.reject(_unmountComponentError);
  }
};

var logger$7 = createLogger('FitMeBetter');

var fitMeBetter = function fitMeBetter() {
  return new Promise(function (resolve, reject) {
    try {
      if (vmIsInitialized() && VmStore.getState().mirror.mirrorStatus === 'TRACKING') {
        AnalyticsHelper.onAdjustGlasses(VmStore.getState().mirror.glasses.upc, VmStore.getState().mirror.mirrorOptions.transitionColor);
        VmStore.dispatch(MirrorActions.setMirrorStatus('RESET'));
        sendAppViewSession.fitMeBetter();
        resolve();
      } else {
        reject();
      }
    } catch (e) {
      logger$7.error('resetting mirror failed: {}', e.message);
      sendAppViewSession.fitMeBetterError();
      reject();
    }
  });
};

var RequestHelper = {
  login: function login(environment) {
    return loginRequest({
      environment: environment,
      accessToken: VmStore.getState().app.auth.accessToken,
      refreshToken: VmStore.getState().app.auth.refreshToken,
      onAuthUpdated: CallbackHelper.onAuthUpdated,
      version: 1
    });
  }
};

var getBipaVersion = function getBipaVersion() {
  if (!vmIsInitialized()) {
    return Promise.reject(new NotInitializedError());
  }

  if (!FeatureLicensingService.isFeatureAuthorized(Features.VM_GET_BIPA_VERSION)) {
    return Promise.reject(new FeatureUnavailableError(Features.VM_GET_BIPA_VERSION));
  }

  return RequestHelper.login(VmStore.getState().app.environment).then(function () {
    return BipaManager.getBipaVersion({
      environment: VmStore.getState().app.environment,
      locale: VmStore.getState().user.locale,
      accessToken: VmStore.getState().app.auth.accessToken,
      refreshToken: VmStore.getState().app.auth.refreshToken,
      onAuthUpdated: CallbackHelper.onAuthUpdated
    });
  });
};

var Events = {
  PAUSE: 'vm_pause_event',
  RESUME: 'vm_resume_event',
  TOPIC_SCREENSHOT_REQ: 'TOPIC_SCREENSHOT_REQ',
  TOPIC_SCREENSHOT_RES: 'TOPIC_SCREENSHOT_RES'
};

var logger$6 = createLogger('GetScreenshot');

var getScreenshot = function getScreenshot() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image/jpeg';
  var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;

  if (!FeatureLicensingService.isFeatureAuthorized(Features.VM_SCREENSHOT)) {
    return Promise.reject(new FeatureUnavailableError(Features.VM_SCREENSHOT));
  }

  var subscriber;
  var promise = new Promise(function (resolve) {
    subscriber = PubSub.subscribe(Events.TOPIC_SCREENSHOT_RES, function (mess, data) {
      AnalyticsHelper.onScreenshot(VmStore.getState().mirror.glasses.upc, VmStore.getState().mirror.mirrorOptions.transitionColor);
      logger$6.debug('message reveived from topic {}: total img bytes {}', mess, data.imgURI.length);
      resolve({
        imgURI: data.imgURI,
        width: data.w,
        height: data.h
      });
    });
    logger$6.debug('subscription for {}: {}', Events.TOPIC_SCREENSHOT_RES, subscriber);
  });
  promise.then(function () {
    if (subscriber) {
      PubSub.unsubscribe(subscriber);
      logger$6.debug('unsubscribed for {}: {}', Events.TOPIC_SCREENSHOT_RES, subscriber);
    }
  });
  var isPublished = PubSub.publish(Events.TOPIC_SCREENSHOT_REQ, {
    type: type,
    quality: quality
  });
  logger$6.debug('published screenshot request on {}: {}', Events.TOPIC_SCREENSHOT_REQ, isPublished);
  return promise;
};

var defaultLocale = 'en-US';
var defaultLanguage = 'en';
var localeMap = {
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  nl: 'nl-NL',
  pl: 'pl-PL',
  pt: 'pt-PT',
  sv: 'sv-SE',
  tr: 'tr-TR',
  zh: 'zh-CN'
};
var defaultTranslations = {
  MIRROR: {
    GENERIC_ERROR: {
      BUTTON: 'Continue',
      ERROR: 'An error occured',
      SUBTEXT: 'Please check your camera permissions and try to reload the page.'
    },
    PERMISSION_ERROR: {
      ERROR: 'You must allow access to your camera to use Virtual Mirror.',
      SUBTEXT: 'Click on your browser Share or Allow button to enable your webcam.'
    },
    WEBCAM_ERROR: {
      ERROR: 'We could not detect your webcam.',
      SUBTEXT: 'Enable webcam access in your browser and refresh the page to continue.'
    },
    MANUAL_START: {
      BUTTON: 'Start the experience',
      TEXT: 'You are probably in Low Power Mode. The experience may be degraded.'
    },
    GUIDANCE: {
      DEFAULT: 'Place your head in the middle of the screen',
      GLASSES: 'Please remove your glasses',
      LOOK_DOWN: 'Look down',
      LOOK_LEFT: 'Look to your left',
      LOOK_RIGHT: 'Look to your right',
      LOOK_UP: 'Look up',
      MOVE_CLOSER: 'Move closer to the oval',
      MOVE_FARTHER: 'Move farther from the screen',
      STAY_STILL: 'Good, stay still while fitting glasses',
      TILT_LEFT: 'Tilt to your left',
      TILT_RIGHT: 'Tilt to your right',
      UNKNOWN: 'Is anyone there?'
    },
    UI: {
      DESKTOP_TAP_TO_FREEZE: 'Hold to freeze the screen or drag the pointer along the nose to adjust the frames',
      FIT_ME_BETTER: 'Fit me better',
      TAP_TO_FREEZE: 'Tap and hold to freeze the screen',
      USE_TWO_FINGERS: 'Use two fingers to adjust on the nose'
    }
  }
};
var LocalizationDefaults = {
  locale: defaultLocale,
  language: defaultLanguage,
  localeMap: localeMap,
  translations: defaultTranslations
};

var logger$5 = createLogger('LocalizationHelper');
var LocalizationHelper = /*#__PURE__*/function () {
  function LocalizationHelper() {
    _classCallCheck(this, LocalizationHelper);
  }

  _createClass(LocalizationHelper, null, [{
    key: "getString",
    value: function getString(page, key) {
      var text = '';

      try {
        text = LocalizationHelper.getStringFromTranslation(page, key, this.localizedTranslations);
      } catch (e) {
        logger$5.warn("local translation not found for [".concat(this.translationType, "][").concat(page, "][").concat(key, "] using default"));

        try {
          text = LocalizationHelper.getStringFromTranslation(page, key, LocalizationDefaults.translations);
        } catch (e) {
          logger$5.warn("default translation not found for [".concat(this.translationType, "][").concat(page, "][").concat(key, "]"));
        }
      }

      return text;
    }
  }, {
    key: "getStringFromTranslation",
    value: function getStringFromTranslation(page, key, translation) {
      var _this$overriddenTrans, _this$overriddenTrans2, _this$overriddenTrans3;

      var text = (_this$overriddenTrans = this.overriddenTranslations) === null || _this$overriddenTrans === void 0 ? void 0 : (_this$overriddenTrans2 = _this$overriddenTrans[this.translationType]) === null || _this$overriddenTrans2 === void 0 ? void 0 : (_this$overriddenTrans3 = _this$overriddenTrans2[page]) === null || _this$overriddenTrans3 === void 0 ? void 0 : _this$overriddenTrans3[key];
      return !!text ? text : translation[this.translationType][page][key];
    }
  }, {
    key: "setOverrides",
    value: function setOverrides(translations) {
      this.overriddenTranslations = {
        MIRROR: translations
      };
    }
  }, {
    key: "initializeRemote",
    value: function initializeRemote(environment, locale, region, bipaActive) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.localizationPromise(environment, locale, region, bipaActive).then(function (localeReturn) {
          _this.localizedTranslations = localeReturn.localTranslations;
          resolve(localeReturn.locale);
        })["catch"](function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "cleanLocale",
    value: function cleanLocale(locale, region, bipaActive) {
      // virtual-mirror.luxottica.com uses navigator.language to detect locale
      // on iOS navigator.language returns 'it' instead of 'it-IT'
      // this tries to handle the value
      var formattedLocale = locale;

      if (bipaActive && region === 'US' && locale !== 'en-US' && locale !== 'es-US') {
        logger$5.warn('invalid locale for privacy policy, reverting to \'en-US\'');
        formattedLocale = 'en-US';
      } else if (!formattedLocale || formattedLocale.length === 2) {
        formattedLocale = LocalizationDefaults.localeMap[formattedLocale] || 'en-US';
      }

      formattedLocale = formattedLocale.replace(LocalizationHelper.formatLocaleRegEx, function (match, p1, p2) {
        return [p1, p2.toUpperCase()].join('-');
      });
      return formattedLocale;
    }
  }, {
    key: "getDefaults",
    value: function getDefaults() {
      return LocalizationDefaults.translations.MIRROR;
    }
  }]);

  return LocalizationHelper;
}();

_defineProperty(LocalizationHelper, "baseUrl", 'https://d5nhc6q3o19l2.cloudfront.net');

_defineProperty(LocalizationHelper, "localeRegEx", new RegExp(/([a-z]{2})-([A-Z]{2}|[0-9]*)/));

_defineProperty(LocalizationHelper, "localeIsoRegEx", new RegExp(/([a-z]{2})-[A-Z]{2}/));

_defineProperty(LocalizationHelper, "formatLocaleRegEx", new RegExp(/([a-z]{2})-([A-Z|a-z]{2})/));

_defineProperty(LocalizationHelper, "localizedTranslations", void 0);

_defineProperty(LocalizationHelper, "overriddenTranslations", void 0);

_defineProperty(LocalizationHelper, "translationType", 'MIRROR');

_defineProperty(LocalizationHelper, "fetchLocalization", function (environment, locale) {
  var textEnv;

  switch (environment) {
    case 'STAGING':
      textEnv = 'dev';
      break;

    case 'ACCEPTANCE':
      textEnv = 'test';
      break;

    case 'PRODUCTION':
      textEnv = 'prod';
      break;
  }

  var localizationFileUrl = "".concat(LocalizationHelper.baseUrl, "/vmmv/v1/").concat(textEnv, "/ui/application_").concat(locale, ".json");
  return fetch(localizationFileUrl).then(function (response) {
    if (response.ok) {
      return response.json();
    } else {
      throw Error("failed to find localization for locale: ".concat(locale));
    }
  }).then(function (json) {
    return json;
  });
});

_defineProperty(LocalizationHelper, "localizationPromise", function (environment, locale, region, bipaActive) {
  return new Promise(function (resolve) {
    var formattedLocale = LocalizationHelper.cleanLocale(locale, region, bipaActive);
    var resolvedLocale = formattedLocale;
    var localeLanguage = LocalizationHelper.localeRegEx.exec(formattedLocale);
    var language = localeLanguage && localeLanguage[1] || LocalizationDefaults.language;

    if (!localeLanguage) {
      var localeError = new InvalidLocaleError(locale);
      logger$5.error(JSON.stringify(localeError)); // tslint:disable-next-line: no-console

      console.warn(localeError);
    }

    var translationFound = false;
    LocalizationHelper.fetchLocalization(environment, formattedLocale).then(function (translation) {
      translationFound = true;
      resolve({
        locale: formattedLocale,
        localTranslations: translation
      });
    })["catch"](function () {
      logger$5.warn("failed to find localization for locale: ".concat(formattedLocale, ", trying with ").concat(LocalizationDefaults.localeMap[language]));
    }).then(function () {
      resolvedLocale = LocalizationDefaults.localeMap[language];

      if (!translationFound) {
        return LocalizationHelper.fetchLocalization(environment, resolvedLocale);
      } else {
        throw Error('break');
      }
    }).then(function (fallbackTranslation) {
      translationFound = true;
      resolve({
        locale: resolvedLocale,
        localTranslations: fallbackTranslation
      });
    })["catch"](function () {
      if (!translationFound) {
        logger$5.warn("failed to find localization language ".concat(language, " mapped as locale: ").concat(resolvedLocale));
      }
    }).then(function () {
      if (!translationFound) {
        resolvedLocale = LocalizationDefaults.locale;
        return LocalizationHelper.fetchLocalization(environment, resolvedLocale);
      } else {
        throw Error('break');
      }
    }).then(function (englishTranslation) {
      translationFound = true;
      resolve({
        locale: resolvedLocale,
        localTranslations: englishTranslation
      });
    })["catch"](function () {
      if (!translationFound) {
        logger$5.warn("failed to find localization for locale: ".concat(resolvedLocale, ", falling back to default ").concat(LocalizationDefaults.locale));
      }

      return Promise.resolve();
    }).then(function () {
      if (!translationFound) {
        resolve({
          locale: resolvedLocale,
          localTranslations: LocalizationDefaults.translations
        });
      }
    });
  });
});

var SupportedFeaturesHelper = /*#__PURE__*/function () {
  function SupportedFeaturesHelper() {
    _classCallCheck(this, SupportedFeaturesHelper);
  }

  _createClass(SupportedFeaturesHelper, null, [{
    key: "getSupportedFeatures",
    value: function getSupportedFeatures() {
      return new Promise(function (resolve, reject) {
        var devicedetection = new DeviceDetection();
        return devicedetection.isVideoInputDeviceAvailable().then(function (available) {
          if (!available) {
            AnalyticsHelper.onWebcamUnavailable();
          }

          resolve({
            wasmSupport: devicedetection.isWebAssemblySupported(),
            webcamAccess: devicedetection.isUserMediaSupported(),
            webcamAvailable: available,
            webglRendering: devicedetection.isWebGlSupported(),
            isWebView: devicedetection.isWebView()
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }
  }]);

  return SupportedFeaturesHelper;
}();

var InitializationHelper = /*#__PURE__*/function () {
  function InitializationHelper() {
    _classCallCheck(this, InitializationHelper);
  }

  _createClass(InitializationHelper, null, [{
    key: "initialize",
    value: function initialize(initOptions, privacyOptions) {
      return Promise.all([LocalizationHelper.initializeRemote(initOptions.environment, initOptions.locale, privacyOptions.region, privacyOptions.bipaActive), SupportedFeaturesHelper.getSupportedFeatures()]).then(function (result) {
        return {
          userStore: {
            locale: result[0],
            region: privacyOptions.region,
            source: privacyOptions.source,
            brand: initOptions.brand,
            storeId: initOptions.storeId,
            channel: initOptions.channel
          },
          supportedFeatures: result[1]
        };
      })["catch"](function (error) {
        throw error;
      });
    }
  }]);

  return InitializationHelper;
}();

var FpsCounter = /*#__PURE__*/function () {
  function FpsCounter() {
    _classCallCheck(this, FpsCounter);

    _defineProperty(this, "fpsQueue", void 0);

    _defineProperty(this, "processStartTime", void 0);

    this.fpsQueue = new Array(FpsCounter.fpsQueueLength).fill(0);
  }

  _createClass(FpsCounter, [{
    key: "fps",
    get: function get() {
      return this.fpsQueue.reduce(function (sum, value) {
        return sum + value;
      }) / this.fpsQueue.length;
    }
  }, {
    key: "tick",
    value: function tick() {
      this.fpsQueue.shift();
      this.fpsQueue.push(FpsCounter.calcFps(this.processStartTime, performance.now()));
      this.processStartTime = performance.now();
    }
  }], [{
    key: "calcFps",
    value: function calcFps(t0, t1) {
      return !(t0 && t1) ? 0 : 1 / ((t1 - t0) / 1000);
    }
  }]);

  return FpsCounter;
}();

_defineProperty(FpsCounter, "fpsQueueLength", 30);

var DefaultAssetEnvironmentOptions = {
  glasses: 'PROD',
  video: 'PRODUCTION',
  wasm: 'PROD'
};

var DefaultPrivacyOptions = {
  bipaActive: false,
  region: undefined,
  source: undefined,
  privacyPolicy: undefined,
  termsAndConditions: undefined,
  bipaPrefill: {
    firstName: undefined,
    lastName: undefined,
    email: undefined
  },
  localizationText: undefined
};

var RevealFX;

(function (RevealFX) {
  RevealFX["OFF"] = "OFF";
  RevealFX["STANDARD"] = "STANDARD";
})(RevealFX || (RevealFX = {}));

var DefaultRenderingOptions = {
  revealFX: RevealFX.OFF,
  debug: {
    checkError: false,
    hideGlasses: false,
    showMesh: false,
    meshColor: [0, 1, 0, 0.5]
  }
};

var DefaultTrackingOptions = {
  debug: false,
  inspect: false,
  recoveryLimit: 1,
  areaSize: 1,
  areaOffset: [0, 0],
  depthRange: [100, 2000],
  axisRange: [7, 50, 7],
  fittedPointsRatio: 0.25,
  fov: 52.0,
  minimumFaceSizeRatio: 0.3,
  edgeDetectionPercentage: [0.15, 0.1, 0.1, 0.1],
  nudgingType: 2,
  standstill: {
    timeLimit: 1500,
    positionVariance: 50,
    axisVariance: 8,
    depthRange: [150, 500]
  },
  onPoseTrack: function onPoseTrack() {
    return;
  }
};

var ParameterHelper = /*#__PURE__*/function () {
  function ParameterHelper() {
    _classCallCheck(this, ParameterHelper);
  }

  _createClass(ParameterHelper, null, [{
    key: "mergeInitializationParams",
    value: function mergeInitializationParams(params) {
      var initOptions = _objectSpread2(_objectSpread2({}, DefaultInitializationOptions), params.options);

      var privacyOptions = _objectSpread2(_objectSpread2({}, DefaultPrivacyOptions), params.privacy);

      var initializationParams = {
        options: initOptions,
        auth: _objectSpread2({}, params.auth),
        privacy: privacyOptions,
        privacyCallbacks: params.privacyCallbacks
      };

      if (!!(privacyOptions !== null && privacyOptions !== void 0 && privacyOptions.bipaActive)) {
        if (!['US', 'AU', 'EU'].includes(privacyOptions.region)) {
          throw new InvalidParametersError('region', privacyOptions.region);
        }

        if (!privacyOptions.source) {
          throw new InvalidParametersError('source', privacyOptions.source);
        }
      }

      return initializationParams;
    }
  }, {
    key: "mergeMirrorOptions",
    value: function mergeMirrorOptions(target, glassesType, inputOptions) {
      var options = inputOptions ? inputOptions : {};
      var size = options.width && options.height ? {
        width: options.width,
        height: options.height
      } : this.createOptionsForTarget(target);
      var faceRatio = this.calculateMinimumPointsRatio(size.width, size.height);
      var mirrorOptions = {
        width: size.width,
        height: size.height,
        transitionColor: options.transitionColor,
        videoResolution: options.videoResolution ? options.videoResolution : 720,
        glassesResolution: options.glassesResolution ? options.glassesResolution : '512',
        glassesType: glassesType ? glassesType : 'B3D',
        device: _objectSpread2({
          evaluationThreshold: FpsCounter.fpsQueueLength / 10 * 1000
        }, options.device),
        rendering: {
          revealFX: options.rendering && options.rendering.revealFX ? options.rendering.revealFX : DefaultRenderingOptions.revealFX,
          debug: _objectSpread2(_objectSpread2({}, DefaultRenderingOptions.debug), options.rendering ? options.rendering.debug : {})
        },
        nosePosition: {
          enabled: options.nosePosition !== undefined && options.nosePosition.enabled !== undefined && typeof options.nosePosition.enabled === 'boolean' ? options.nosePosition.enabled : true,
          touches: this.calculateAutoPointerCount(options.nosePosition)
        },
        tracking: _objectSpread2(_objectSpread2(_objectSpread2({}, DefaultTrackingOptions), {}, {
          minimumFaceSizeRatio: faceRatio
        }, options.tracking), {}, {
          standstill: _objectSpread2(_objectSpread2({}, DefaultTrackingOptions.standstill), options.tracking ? options.tracking.standstill : {})
        }),
        fittingModel: this.calculateFittingModel(options.fittingModel),
        environment: _objectSpread2(_objectSpread2({}, DefaultAssetEnvironmentOptions), options.environment ? options.environment : {})
      }; // IMPORTANT
      // This toUpperCase has been added to quick go in production on Jun 27th 2022 on Oakley configurator
      // The configutator wrongly return lowercase environments and now is too late to release a client side fix

      mirrorOptions.environment.glasses = mirrorOptions.environment.glasses.toUpperCase();
      return mirrorOptions;
    }
  }, {
    key: "calculateAutoPointerCount",
    value: function calculateAutoPointerCount(nosePosition) {
      var enabled = (nosePosition === null || nosePosition === void 0 ? void 0 : nosePosition.enabled) !== undefined ? nosePosition.enabled : true;
      var touches = (nosePosition === null || nosePosition === void 0 ? void 0 : nosePosition.touches) !== undefined ? nosePosition.touches : -1;

      if (enabled && touches && [1, 2].includes(touches)) {
        return touches;
      } else {
        return device.mobile() || device.tablet() || this.isTouchDevice() ? 2 : 1;
      }
    }
  }, {
    key: "isTouchDevice",
    value: function isTouchDevice() {
      var result = false;

      if (window.PointerEvent && 'maxTouchPoints' in navigator) {
        // if Pointer Events are supported, just check maxTouchPoints
        if (navigator.maxTouchPoints > 0) {
          result = true;
        }
      } else {
        // no Pointer Events...
        if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
          // check for any-pointer:coarse which mostly means touchscreen
          result = true;
        } else if (window.TouchEvent || 'ontouchstart' in window) {
          // last resort - check for exposed touch events API / event handler
          result = true;
        }
      }

      return result;
    }
  }, {
    key: "calculateMinimumPointsRatio",
    value: function calculateMinimumPointsRatio(width, height) {
      var estimatedRadius = 0.35;
      var estimatedTrackingArea = Math.PI * Math.pow(estimatedRadius * height, 2);
      var ratio = estimatedTrackingArea / (width * height);
      return ratio;
    }
  }, {
    key: "createOptionsForTarget",
    value: function createOptionsForTarget(target) {
      var targetElement = document.getElementById(target);
      var options = {
        width: 0,
        height: 0
      };

      if (!targetElement) {
        return options;
      }

      if (this.elementHasSize(targetElement)) {
        options = {
          height: targetElement.clientHeight,
          width: targetElement.clientWidth
        };
      } else if (targetElement.parentElement && this.elementHasSize(targetElement.parentElement)) {
        options = {
          height: targetElement.parentElement.clientHeight,
          width: targetElement.parentElement.clientWidth
        };
      }

      return options;
    }
  }, {
    key: "elementHasSize",
    value: function elementHasSize(element) {
      return element.clientWidth > 0 && element.clientHeight > 0;
    }
  }, {
    key: "calculateFittingModel",
    value: function calculateFittingModel(meshOptions) {
      return meshOptions ? {
        videoId: meshOptions.videoId ? meshOptions.videoId : undefined,
        pupillaryDistance: meshOptions.pupillaryDistance ? meshOptions.pupillaryDistance : 63
      } : {
        videoId: undefined,
        pupillaryDistance: 63
      };
    }
  }, {
    key: "glassesAreReady",
    value: function glassesAreReady(glasses) {
      if (!!glasses) {
        return glasses.status === 'READY';
      } else {
        return false;
      }
    }
  }]);

  return ParameterHelper;
}();

var logger$4 = createLogger('Initialize');
var errorListenerAdded = false;

var initialize = function initialize(params) {
  if (!errorListenerAdded) {
    window.addEventListener('error', function (event) {
      sendError(event.error);
    });
    errorListenerAdded = true;
  }

  return FeatureLicensingService.initialize(params.options.key, params.options.environment).then(function () {
    var validatedParams = ParameterHelper.mergeInitializationParams(params);

    if (validatedParams.privacy.bipaActive && !FeatureLicensingService.isFeatureAuthorized(Features.VM_BIPA)) {
      throw new FeatureUnavailableError(Features.VM_BIPA);
    }

    var options = validatedParams.options;
    AnalyticsHelper.initialize(options.environment, options.analyticsConfig, {
      brand: options.brand,
      channel: options.channel,
      locale: options.locale,
      storeId: options.storeId,
      storeRegion: options.storeRegion,
      storeCompany: options.storeCompany,
      globalStoreId: options.globalStoreId
    });
    setSessionTimeout(options.sessionTimeout);
    logger$4.debug('initializing virtual mirror [channel={},brand={},locale={},storeId={}]', options.channel, options.brand, options.locale, options.storeId);
    return Promise.all([InitializationHelper.initialize(validatedParams.options, validatedParams.privacy), Promise.resolve(options)]);
  }).then(function (initReturn) {
    var _params$auth, _params$auth2;

    if (VmStore === undefined) {
      configureVmStore();
    }

    setCallbacks(params.options.callbacks);
    setPrivacyCallbacks(params.privacyCallbacks);
    var userStore = initReturn[0].userStore;
    var supportedFeatures = initReturn[0].supportedFeatures;
    var options = initReturn[1];

    if (options.environment !== VmStore.getState().app.environment) {
      VmStore.dispatch(AppActions.resetAuth());
    }

    VmStore.dispatch(AppActions.setAuth({
      accessToken: (_params$auth = params.auth) === null || _params$auth === void 0 ? void 0 : _params$auth.accessToken,
      refreshToken: (_params$auth2 = params.auth) === null || _params$auth2 === void 0 ? void 0 : _params$auth2.accessToken
    }));
    VmStore.dispatch(AppActions.setEnvironment(options.environment));
    VmStore.dispatch(AppActions.setPrivacyOptions(params.privacy));
    VmStore.dispatch(AppActions.setLoadingStatus({
      type: 'INITIALIZATION',
      status: true
    }));
    VmStore.dispatch(UserActions.setUser(userStore));
    logger$4.info('virtual mirror initialized with options {}', JSON.stringify(options));
    AnalyticsHelper.onInitializeSuccess();
    sendAppViewSession.initialize(options);
    return {
      userId: undefined,
      locale: userStore.locale,
      supportedFeatures: supportedFeatures
    };
  })["catch"](function (e) {
    logger$4.error('virtual mirror initialization failed with options {} [{}]', JSON.stringify(params.options), JSON.stringify(e));
    AnalyticsHelper.onInitializeError();
    sendAppViewSession.initializeError(params.options);
    throw e;
  });
};

var logger$3 = createLogger('VmWebCam');
var VmWebCam = /*#__PURE__*/function () {
  function VmWebCam() {
    _classCallCheck(this, VmWebCam);

    _defineProperty(this, "webCam", void 0);

    _defineProperty(this, "webCamStream", void 0);

    this.webCam = new WebCam();
  }

  _createClass(VmWebCam, [{
    key: "tryToOpenWebCam",
    value: function tryToOpenWebCam(w, h) {
      return this.webCam.tryToOpenWebCam(w, h, 'user');
    }
  }, {
    key: "initStreamObject",
    value: function initStreamObject(options, stream) {
      this.webCamStream = this.createStreamObject(options, stream);
    }
  }, {
    key: "closeCurrentMediaStream",
    value: function closeCurrentMediaStream() {
      this.webCam.closeCurrentMediaStream();
    }
  }, {
    key: "pause",
    value: function pause() {
      var deviceDetection = new DeviceDetection();

      if (!this.webCamStream.isNativeStream() && deviceDetection.isAppleiOS13()) {
        logger$3.warn('Can\'t pause Webcam on iOS 13 device due a bug that would freeze video stream on resume playing');
        return;
      }

      this.webCamStream.streamObject.pause();
    }
  }, {
    key: "play",
    value: function play() {
      return this.webCamStream.streamObject.play();
    }
  }, {
    key: "stream",
    get: function get() {
      return this.webCamStream;
    }
  }, {
    key: "createStreamObject",
    value: function createStreamObject(options, stream) {
      return this.webCam.createStreamObject(options, stream);
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!VmWebCam.instance) {
        VmWebCam.instance = new VmWebCam();
      }

      return VmWebCam.instance;
    }
  }]);

  return VmWebCam;
}();

_defineProperty(VmWebCam, "instance", void 0);

var pause = function pause() {
  if (!vmIsInitialized()) {
    return;
  } else {
    VmWebCam.getInstance().pause();
    EventBus.publish(Events.PAUSE, {});
  }
};

var logger$2 = createLogger('RenderMirror');

var getUpcAvailability = function getUpcAvailability(glassesConfig, upc) {
  return Catalog.getUpcAvailability(glassesConfig, upc);
};

var isDistributorEnv = function isDistributorEnv(glassesEnvironment) {
  return glassesEnvironment === GlassesEnvironment.DISTRIBUTOR_APPROVATION_PRODUCTION || glassesEnvironment === GlassesEnvironment.DISTRIBUTOR_APPROVATION_STAGING || glassesEnvironment === GlassesEnvironment.DISTRIBUTOR_VALIDATION_PRODUCTION || glassesEnvironment === GlassesEnvironment.DISTRIBUTOR_VALIDATION_STAGING;
};

var renderMirror = function renderMirror(params) {
  var _options$environment;

  if (!vmIsInitialized()) {
    return Promise.reject(new NotInitializedError());
  }

  var target = params.target,
      upc = params.upc,
      options = params.options;
  AnalyticsHelper.onSessionStart();
  var glassesConfig = {
    // IMPORTANT
    // This toUpperCase has been added to quick go in production on Jun 27th 2022 on Oakley configurator
    // The configutator wrongly return lowercase environments and now is too late to release a client side fix
    env: !!(options !== null && options !== void 0 && (_options$environment = options.environment) !== null && _options$environment !== void 0 && _options$environment.glasses) ? options.environment.glasses.toUpperCase() : DefaultAssetEnvironmentOptions.glasses
  }; // TODO: should transition colors be downloaded on every render?

  return Promise.all([getUpcAvailability(glassesConfig, upc), TransitionColorHelper.downloadTransitionColors(glassesConfig)]).then(function (result) {
    var upcAvailability = result[0]; // TODO: improve glasses type management

    var glassesType = upcAvailability.glassesType; // (options.glassesType) ? options.glassesType : 'B3D';
    // TODO: leave for mock env

    if (glassesConfig.env === GlassesEnvironment.MOCK) {
      logger$2.debug('rendering virtual mirror for upc {} on target {}', upc, target);
      sendAppViewSession.upc(upc);
      var mergedOptions = ParameterHelper.mergeMirrorOptions(target, glassesType, options);
      return renderMirrorPromise(target, upcAvailability, mergedOptions);
    } else {
      if (glassesType === 'B3D' && (upcAvailability.available[256] || upcAvailability.available[512] || isDistributorEnv(glassesConfig.env)) || glassesType === 'GLTF' && (!!upcAvailability.lods.includes(1) || !!upcAvailability.lods.includes(2))) {
        logger$2.debug('rendering virtual mirror for upc {} on target {}', upc, target);
        sendAppViewSession.upc(upc);

        var _mergedOptions = ParameterHelper.mergeMirrorOptions(target, glassesType, options);

        return renderMirrorPromise(target, upcAvailability, _mergedOptions);
      } else {
        logger$2.warn('rendering virtual mirror not possible: upc {} isn\'t supported', upc);
        sendAppViewSession.upcError(upc);
        var upcMissingError = new UpcMissingError(upc);
        AdobeHelper.sendError(upcMissingError, upc);
        throw upcMissingError;
      }
    }
  });
};

var renderMirrorPromise = function renderMirrorPromise(target, upcAvailability, mirrorOptions) {
  return new Promise(function (resolve, reject) {
    import(
    /* webpackChunkName: "MirrorAsyncRoot" */
    './virtual-mirror-MirrorAsyncRoot-d157c91e.js').then(function (_ref) {
      var MirrorAsyncRoot = _ref.MirrorAsyncRoot;
      VmStore.dispatch(MirrorActions.setMirrorOptions(mirrorOptions));
      logger$2.debug('vm default tracking options: {}', JSON.stringify(DefaultTrackingOptions));
      logger$2.debug('vm mirror options: {}', JSON.stringify(mirrorOptions));
      logger$2.debug('mounting render mirror component on div {}', target);

      try {
        var container = document.getElementById(target);

        if (container) {
          MirrorAsyncRoot.mountMirror(container, VmStore, upcAvailability, resolve, reject, mirrorOptions);
          addHandlerForOrientationChange();
        } else {
          var mountComponentError = new MountComponentError(target);
          AdobeHelper.sendError(mountComponentError);
          reject(mountComponentError);
        }
      } catch (e) {
        var _mountComponentError = new MountComponentError(target);

        AdobeHelper.sendError(_mountComponentError);
        reject(_mountComponentError);
      }
    })["catch"](function (e) {
      logger$2.error(e);
      var mountComponentError = new MountComponentError(target);
      AdobeHelper.sendError(mountComponentError);
      reject(mountComponentError);
    });
  });
};

var addHandlerForOrientationChange = function addHandlerForOrientationChange() {
  if (window) {
    window.addEventListener('orientationchange', function () {
      var landscape = window.orientation === 90 || window.orientation === -90;
      logger$2.debug('orientation change detected [new value is {} - landscape: {}]', window.orientation, landscape);
      sendAppViewSession.orientationChange(landscape);
      window.setTimeout(function () {
        return fitMeBetter();
      }, 150);
    });
  }
};

var logger$1 = createLogger('Resume');

var resume = function resume() {
  if (!vmIsInitialized()) {
    return Promise.reject(new NotInitializedError());
  } else {
    return VmWebCam.getInstance().play().then(function () {
      EventBus.publish(Events.RESUME, {});
    })["catch"](function (e) {
      logger$1.error(e);
    });
  }
};

var saveBipaEntry = function saveBipaEntry(params) {
  if (!vmIsInitialized()) {
    return Promise.reject(new NotInitializedError());
  }

  if (!FeatureLicensingService.isFeatureAuthorized(Features.VM_SAVE_BIPA_ENTRY)) {
    return Promise.reject(new FeatureUnavailableError(Features.VM_SAVE_BIPA_ENTRY));
  }

  return RequestHelper.login(VmStore.getState().app.environment).then(function () {
    return BipaManager.saveBipaEntry({
      environment: VmStore.getState().app.environment,
      source: VmStore.getState().app.privacy.source,
      accessToken: VmStore.getState().app.auth.accessToken,
      refreshToken: VmStore.getState().app.auth.refreshToken,
      bipaVersion: params.bipaVersion,
      formData: {
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email
      },
      onAuthUpdated: CallbackHelper.onAuthUpdated
    });
  });
};

var setTransitionOpacity = function setTransitionOpacity() {
  var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (!vmIsInitialized()) {
    throw new NotInitializedError();
  }

  if (opacity !== undefined) {
    if (typeof opacity !== 'number' || opacity < 0 || opacity > 1) {
      var error = new OpacityError('opacity must be a number between 0 and 1');
      throw error;
    }

    TransitionColorHelper.setCurrentLensOpacity(opacity);
  } else {
    var _error = new OpacityError('opacity cannot be set when mirror is not initialized');

    throw _error;
  }
};

var logger = createLogger('SetTransitionOverrideColor');

var setTransitionOverrideColor = function setTransitionOverrideColor(transitionColor) {
  logger.debug('setting new override color', transitionColor);
  TransitionColorHelper.setTransitionOverrideColor(transitionColor);
};

var Catalogue = /*#__PURE__*/function () {
  function Catalogue(env) {
    _classCallCheck(this, Catalogue);

    Catalogue.config = {
      env: env
    };
  }

  _createClass(Catalogue, [{
    key: "isUpcSupported",
    value: function isUpcSupported() {
      var result = {};

      for (var _len = arguments.length, upcs = new Array(_len), _key = 0; _key < _len; _key++) {
        upcs[_key] = arguments[_key];
      }

      upcs.forEach(function (upc) {
        result[upc] = Catalog.getUpcAvailability(Catalogue.config, upc);
      });
      return result;
    }
  }, {
    key: "downloadTransitionColorCatalogue",
    value: function downloadTransitionColorCatalogue() {
      return Catalogue.featureLicensingInitialization.then(function () {
        if (FeatureLicensingService.isFeatureAuthorized(Features.VM_TRANSITIONS)) {
          return Catalog.downloadTransitionColors(Catalogue.config);
        } else {
          return Promise.resolve({});
        }
      });
    }
  }], [{
    key: "build",
    value: function build(_ref) {
      var catalogueEnvironment = _ref.catalogueEnvironment,
          featureLicensingEnv = _ref.featureLicensingEnv,
          key = _ref.key;
      this.featureLicensingInitialization = FeatureLicensingService.initialize(key, !!featureLicensingEnv ? featureLicensingEnv : 'PRODUCTION');
      return new Catalogue(!!catalogueEnvironment ? catalogueEnvironment : 'PROD');
    }
  }]);

  return Catalogue;
}();

_defineProperty(Catalogue, "config", void 0);

_defineProperty(Catalogue, "featureLicensingInitialization", void 0);

var VirtualMirror = {
  version: function version$1() {
    return 'v' + version;
  },
  initialize: function initialize$1(params) {
    return initialize(params);
  },
  overrideLocalization: function overrideLocalization(translation) {
    return LocalizationHelper.setOverrides(translation);
  },
  getMirrorDefaultLocalization: function getMirrorDefaultLocalization() {
    return LocalizationHelper.getDefaults();
  },
  // ***
  // BIPA FUNCTIONS
  // ***
  getBipaVersion: function getBipaVersion$1() {
    return getBipaVersion();
  },
  saveBipaEntry: function saveBipaEntry$1(params) {
    return saveBipaEntry(params);
  },
  resetBipaState: function resetBipaState() {
    document.cookie = "".concat(BipaManager.getCookieName("BASIC"
    /* BASIC */
    ), "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
    document.cookie = "".concat(BipaManager.getCookieName("BIOMETRIC"
    /* BIOMETRIC */
    ), "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
  },
  // ***
  // RENDER FUNCTIONS
  // ***
  renderMirror: function renderMirror$1(params) {
    return renderMirror(params);
  },
  pause: function pause$1() {
    return pause();
  },
  resume: function resume$1() {
    return resume();
  },
  fitMeBetter: function fitMeBetter$1() {
    return fitMeBetter();
  },
  getScreenshot: function getScreenshot$1() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image/jpeg';
    var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;
    return getScreenshot(type, quality);
  },
  setTransitionOpacity: function setTransitionOpacity$1(params) {
    return setTransitionOpacity(params === null || params === void 0 ? void 0 : params.opacity);
  },
  setTransitionOverrideColor: function setTransitionOverrideColor$1(transitionColor) {
    return setTransitionOverrideColor(transitionColor);
  },
  animateOpacity: function animateOpacity$1() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      duration: 1000
    };
    return animateOpacity(params === null || params === void 0 ? void 0 : params.duration);
  },
  closeMirror: function closeMirror$1(params) {
    return closeMirror(params === null || params === void 0 ? void 0 : params.target);
  }
};

export { AnalyticsHelper as A, CallbackHelper as C, Events as E, FeatureLicensingService as F, LocalizationHelper as L, MirrorActions as M, ParameterHelper as P, RevealFX as R, TransitionColorHelper as T, UpcMissingError as U, VmStore as V, WebcamRejectedError as W, _inherits as _, _createSuper as a, _classCallCheck as b, createLogger as c, _createClass as d, _defineProperty as e, _assertThisInitialized as f, _objectSpread2 as g, dispatchEvent as h, AppViewSessionKeys as i, Features as j, VmWebCam as k, FpsCounter as l, AppActions as m, VtoError as n, VirtualMirror as o, performanceEvents as p, Catalogue as q, UpcSupportedError as r, useBiometricBipa as u };
//# sourceMappingURL=virtual-mirror-VirtualMirror-c63eaa3e.js.map
